<template>
<div class="message-editor">
    <Loader :loading="loading"></Loader>

    <div class="message-editor-buttons">

        <span @click="previousStep" class="close">
            <i class="icon icon-close"></i>
        </span>

		To: Kolkin

        <div class="message-editor-right">
            <span @click="uploadFile" title="Attach file">
                <i class="icon icon-attach"></i>
            </span>

            <span @click="sendMessage" class="send">
                <i class="icon icon-chevron-right"></i>
            </span>
        </div>

    </div>

	<div class="description">
		<input v-model="description" autocomplete="off" id="inputUser" type="text" placeholder="Description">
	</div>
    

    <TicketMessageTiptap ref="tiptap" @selected="fileSelected" @renamed="fileRenamed"></TicketMessageTiptap>



</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import TicketMessageTiptap from "@/components/support/TicketMessageTiptap";
import Loader from "@/../submodules/vue-base/components/Loader";

export default {

    name: "CreateTicketMenu",

    components: {
        TicketMessageTiptap,
        Loader
    },

    data() {
        return {
            isMounted: false,
            description: "",
            listOfFiles: [],
            loading: false,
        };
    },

    mounted() {
        this.isMounted = true;
    },

    methods: {
        fileSelected(fileObject) {
            this.listOfFiles.push(fileObject)
        },

        fileRenamed(renameObject) {

            for (var i = 0; i < this.listOfFiles.length; i++) {
                if (this.listOfFiles[i].uuid == renameObject.uuid) {
                    //you have to remake a file object to remake it
                    const newFile = new File([this.listOfFiles[i].file], renameObject.linkText, {
                        type: this.listOfFiles[i].file.type
                    });
                    this.listOfFiles[i].file = newFile;
                }
            }

        },

        checkUploads() {
            var uploadsArray = this.$refs.tiptap.scanForUploads();
            for (var i = 0; i < this.listOfFiles.length; i++) {
                var foundIndex = uploadsArray.indexOf(this.listOfFiles[i].file.name)
                if (foundIndex == -1) {
                    this.listOfFiles.splice(i, 1);
                    i--;
                } else {
                    uploadsArray.splice(foundIndex, 1);
                }
            }
        },
        uploadFile() {

            this.$refs.tiptap.openGenericModal();
        },

        focusTiptap() {
            this.$refs.tiptap.editor.focus();
        },

        sendMessage() {
            this.checkUploads();

            var html = this.$refs.tiptap.editor.getHTML();
            var text = this.$refs.tiptap.getBody();
            var json = this.$refs.tiptap.editor.getJSON();
            text = text.trim();
            if (!text && html == "<p></p>") {
                return;
            }
            if (this.description == "") {
                return;
            }

            var obj = {
                description: this.description,
                type: "investor",
                json: json,
            };

            var formData = new FormData();
            formData.append("message_json", JSON.stringify(obj));
            for (var i = 0; i < this.listOfFiles.length; i++) {
                formData.append("filename", this.listOfFiles[i].file.name);
                formData.append("file", this.listOfFiles[i].file);
            }
            var temp = this;
            this.$store.dispatch("createSupportTicket", formData).then(function () {
                temp.$store.dispatch("loadInvestorSupportTickets").then(function () {
                    var toastInstance = temp.$toasted.show('Message has been sent', {
                        duration: "3000",
                        className: "toast-success",
                        position: "top-center"
                    });
                    temp.previousStep();
                })
            });
        },

        previousStep() {
            this.$emit("previous")
        },
    },

    computed: {
        editorIsFocused() {

            if (!this.isMounted) {
                return;
            }
            return this.$refs.tiptap.editor.focused;
        },
        ...mapGetters(["user", "supportTicket"])
    },
}
</script>
